// // socketService.js
// import io from "socket.io-client";

// // Initialize Socket connection
// const socket = io("http://192.168.1.19:4000");
// // const socket = io("https://api.itracknet.com");

// // Export any methods needed for handling socket events
// export const connectSocket = (onConnect, onDisconnect, onMessage, onUserLiveLocation) => {
//   socket.on("connect", onConnect);
//   socket.on("disconnect", onDisconnect);
//   socket.on("message", onMessage);
//   socket.on("userLiveLocation", onUserLiveLocation);
// };

// export const disconnectSocket = () => {
//   socket.off("connect");
//   socket.off("disconnect");
//   socket.off("message");
//   socket.off("userLiveLocation");
// };

// export const sendMessage = (message) => {
//   socket.emit("message", message);
// };

// export const userLiveLocation = (live) => {
//   socket.emit("userLiveLocation", userLiveLocation);
// };

// // export const userLiveLocation = (message) => {
// //   socket.emit('message', message);
// // };

// export default socket;

import io from "socket.io-client";
// import {setTracking, stopTracking} from './Tracking';

class SocketService {
  constructor() {
    this.socket = null; // Holds the socket instance
    this.initializedSocket = false;
    this.globalListeners = new Map();
  }

  // Initialize the socket connection
  initializeSocket() {
    return new Promise((resolve, reject) => {
      let userId = localStorage.getItem("userId");
      let isSuperAdmin = localStorage.getItem("superAdmin");
      let state = localStorage.getItem("state");
      let web = true;
      console.log(userId, isSuperAdmin, state);
      if (!userId) {
        console.error("User ID is required to establish a connection.");
        return reject("User ID is required to establish a connection.");
      }
      if (this.initializedSocket && this.socket) {
        resolve();
      }

      //wss://ws.itracknet.com
      //http://192.168.1.19:4000
      //https://api.itracknet.com
      // Establish a socket connection
      this.socket = io("https://api.itracknet.com", {
        query: { userId, state, isSuperAdmin, web },

        // transports: ['websocket'],
      });

      // Handle connection events
      this.socket.on("connect", () => {
        console.log("Socket connected:", this.socket.id);
        this.initializedSocket = true;
        for (const [event, callback] of this.globalListeners.entries()) {
          this.socket.on(event, callback);
        }
        resolve();
      });

      this.socket.on("disconnect", () => {
        console.log("Socket disconnected.");
      });
    });

    // // Handle custom events (example)
    // this.socket.on('arrivalpopup', data => {
    //   console.log('Received event data: arrivalpopup', data);
    //   // setTokenData(true);
    // });

    // this.socket.on('tracking', data => {
    //   console.log("data",data)
    //   if (data.tracking) {
    //     setTracking();
    //   } else {
    //     stopTracking();
    //   }
    // });
  }

  // Emit events
  emit(event, data, callback) {
    // console.log('get data and event1', event, data);
    if (this.socket) {
      // console.log('get data and event', event, data);
      this.socket.emit(event, data, callback);
    } else {
      console.error("Socket is not connected.");
    }
  }

  // Listen to events
  on(event, callback) {
    console.log("event", event);
    this.globalListeners.set(event, callback);
    if (this.socket) {
      this.socket.on(event, callback);
    } else {
      console.error("Socket is not connected.");
    }
  }
  // Listen to events
  removeAllListeners(event) {
    console.log("event", event);

    if (this.socket) {
      this.socket.removeAllListeners(event);
    } else {
      console.error("Socket is not connected.");
    }
  }
  // Disconnect the socket
  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
      this.initializedSocket = false;
    } else {
      console.error("Socket is not connected.");
    }
  }
  isConnected() {
    return this.socket?.connected || false;
  }
}

// Export an instance of the service
const socketService = new SocketService();
export default socketService;
